'use client';

import { useEffect } from 'react';

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    k5aMeta: unknown;
    spaReady?: () => void;
  }
}

export function KilkayaMeta({ meta }: { meta: unknown }) {
  useEffect(() => {
    window.k5aMeta = meta;

    setTimeout(() => {
      if (typeof window.spaReady === 'function') {
        window.spaReady();
      }
      document.dispatchEvent(new Event('K5A:SpaReady'));
    }, 0);
  }, [meta]);

  return null;
}
